<template>
  <div
    class="about-container"
    :style="{ backgroundImage: 'url(' + backgroundGif + ')' }"
  >
    <!-- Back Button -->
    <a class="back-button" @click="goBack">⬅ {{ back_label[language] }}</a>

    <div class="content-container">
      <section class="title-card">
        <h2 class="title title-board">{{ about_title[language] }}</h2>
      </section>

      <section class="card logos-card">
        
        <h3 class="body-text">DUSE - Counteracting diabetes using interdisciplinary educative programs</h3>

        <p class="body-text" v-html="about_body[language]"></p>
        <p class="body-text">{{ funding_text[language] }}</p>

        <div class="logos-row" role="img" aria-label="Project and funding logos">
          <img :src="duseLogo" alt="DUSE logo" class="logo duse-logo" />
          <img :src="euCofundedLogo" alt="Co-funded by the European Union" class="logo eu-logo" />
        </div>
      </section>
    </div>

    </div>
</template>

<script>
import { sounds } from '@/utils/sounds.js';

export default {
  name: 'AboutVitalia',
  data() {
    return {
      backgroundGif: require('@/assets/world/maximum.gif'),
      duseLogo: require('@/assets/about/DUSE logo.png'),
      euCofundedLogo: require('@/assets/about/EN Co-funded by the EU_PANTONE.jpg'),
      language: localStorage.getItem('language') || 'en',

      back_label: { en: 'Back', el: 'Πίσω', it: 'Indietro', ro: 'Înapoi', uk: 'Назад' },
      about_title: {
        en: 'About Vitalia',
        el: 'Σχετικά με τη Vitalia',
        it: 'Informazioni su Vitalia',
        ro: 'Despre Vitalia',
        uk: 'Про Віталію'
      },

      about_body: {
        en: (
          '<p>Vitalia app makes healthy living fun for kids. Designed as an interactive game, it takes children on an adventure in Vitalia, a magical world where they become guardians of the Eternal Olive Tree. Through daily missions, kids engage in physical activities like stretching, jumping, and exercising, while learning about balanced nutrition with games.</p>' +
          '<p>What makes it unique? It uses <strong>augmented reality (AR)</strong> to guide kids through exercises, making workouts feel like play. No personal data are stored, ensuring a safe experience. Parents and educators can track progress, making it a great tool for families and classrooms.</p>' +
          '<p>With colorful graphics, playful characters, and rewards, Vitalia turns healthy habits into an adventure.</p>'
        ),
        el: (
          '<p>H εφαρμογή της Vitalia κάνει την υγιεινή ζωή διασκεδαστική για τα παιδιά. Σχεδιασμένη ως διαδραστικό παιχνίδι, τα ταξιδεύει στη Vitalia, έναν μαγικό κόσμο όπου γίνονται φύλακες της Αιώνιας Ελιάς. Μέσα από καθημερινές αποστολές, τα παιδιά κάνουν διατάσεις, άλματα και ασκήσεις, ενώ μαθαίνουν ισορροπημένη διατροφή μέσα από παιχνίδια.</p>' +
          '<p>Τι την κάνει μοναδική; Χρησιμοποιεί <strong>επαυξημένη πραγματικότητα (AR)</strong> για να καθοδηγεί τις ασκήσεις, ώστε η προπόνηση να μοιάζει με παιχνίδι. Δεν αποθηκεύονται προσωπικά δεδομένα, εξασφαλίζοντας ασφαλή εμπειρία. Γονείς και εκπαιδευτικοί μπορούν να παρακολουθούν την πρόοδο, κάτι που την καθιστά χρήσιμη στο σπίτι και στην τάξη.</p>' +
          '<p>Με πολύχρωμα γραφικά, παιχνιδιάρικους χαρακτήρες και επιβραβεύσεις, η Vitalia μετατρέπει τις υγιεινές συνήθειες σε περιπέτεια.</p>'
        ),
        it: (
          "<p>L’app Vitalia rende il vivere sano divertente per i bambini. Progettata come gioco interattivo, porta i bambini in un’avventura a Vitalia, un mondo magico dove diventano guardiani dell’Ulivo Eterno. Con missioni quotidiane, i bambini svolgono attività fisiche come stretching, salti ed esercizi, mentre imparano l’alimentazione equilibrata attraverso i giochi.</p>" +
          "<p>Cosa la rende unica? Usa la <strong>realtà aumentata (AR)</strong> per guidare i bambini negli esercizi, facendo sembrare l’allenamento un gioco. Non vengono memorizzati dati personali, garantendo un’esperienza sicura. Genitori ed educatori possono monitorare i progressi, rendendola uno strumento utile per le famiglie e le classi.</p>" +
          "<p>Con grafiche colorate, personaggi giocosi e ricompense, Vitalia trasforma le abitudini sane in un’avventura.</p>"
        ),
        ro: (
          '<p>Aplicația Vitalia face viața sănătoasă distractivă pentru copii. Concepută ca un joc interactiv, îi poartă într-o aventură în Vitalia, o lume magică în care devin gardienii Măslinului Etern. Prin misiuni zilnice, copiii se implică în activități fizice precum stretching, sărituri și exerciții, în timp ce învață despre nutriția echilibrată prin jocuri.</p>' +
          '<p>Ce o face unică? Folosește <strong>realitate augmentată (AR)</strong> pentru a ghida copiii în exerciții, făcând antrenamentele să pară joc. Nu se stochează date personale, asigurând o experiență sigură. Părinții și educatorii pot urmări progresul, ceea ce o face un instrument util pentru familii și săli de clasă.</p>' +
          '<p>Cu grafică colorată, personaje jucăușe și recompense, Vitalia transformă obiceiurile sănătoase într-o aventură.</p>'
        ),
        uk: (
          '<p>Застосунок Vitalia робить здоровий спосіб життя веселим для дітей. Створений як інтерактивна гра, він веде дітей у пригоду до Віталії — чарівного світу, де вони стають охоронцями Вічної Оливи. Завдяки щоденним місіям діти виконують фізичні активності, як-от розтяжки, стрибки та вправи, водночас навчаючись збалансованому харчуванню через ігри.</p>' +
          '<p>Що робить його унікальним? Він використовує <strong>доповнену реальність (AR)</strong>, щоб спрямовувати дітей під час вправ, тож тренування відчуваються як гра. Персональні дані не зберігаються, що гарантує безпечний досвід. Батьки та педагоги можуть відстежувати прогрес, тому це чудовий інструмент для сімей і класів.</p>' +
          '<p>З яскравою графікою, веселими персонажами та винагородами Vitalia перетворює здорові звички на пригоду.</p>'
        ),
      },

      funding_text: {
        en: 'This application has been supported by the DUSE EU project (EU4Health-2022-PJ-11 grant number 101128641), funded by the European Union.',
        el: 'Η εφαρμογή αυτή έχει υποστηριχθεί από το έργο DUSE της ΕΕ (EU4Health-2022-PJ-11, αριθμός επιχορήγησης 101128641), που χρηματοδοτείται από την Ευρωπαϊκή Ένωση.',
        it: "Questa applicazione è stata supportata dal progetto DUSE dell'UE (EU4Health-2022-PJ-11, numero di sovvenzione 101128641), finanziato dall'Unione europea.",
        ro: 'Această aplicație a fost susținută de proiectul DUSE al UE (EU4Health-2022-PJ-11, numărul grantului 101128641), finanțat de Uniunea Europeană.',
        uk: 'Цю програму підтримано проєктом ЄС DUSE (EU4Health-2022-PJ-11, номер гранту 101128641), що фінансується Європейським Союзом.'
      },


    };
  },
  methods: {
    async goBack() {
      sounds.whoosh.play();
      this.isShuttingDown = true;
      this.$router.push({ name: "MainScene" }); // Navigate to the Main Scene
    },
  },
  created() {
    this.language = localStorage.getItem("language") || "en";
    console.log("LANGUAGE " + this.language);
  },
  mounted() {
    sounds.settings_menu.play();
  },
  beforeUnmount() {
    sounds.settings_menu.stop();
  },
};
</script>

<style>
.about-container {
  position: fixed;
  inset: 0;
  background-size: cover;
  background-position: center;
  overflow: auto;
  padding: 0 20px 20px;
}

.content-container {
  max-width: 960px;
  margin: 32px auto 40px;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 40px);
  gap: 12px;
}

.card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 14px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
}





.meta {
  margin-top: 8px;
  padding-left: 18px;
}

.body-list {
  padding-left: 18px;
}

@media (max-width: 600px) {
  .content-container {
    margin-top: 32px;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 56px);
  }
  .card { padding: 14px; }
}

.logos-card {
  text-align: center;
  margin-top: 12px;
}
.title-card {
  text-align: center;
  background: transparent;
  box-shadow: none;
  padding: 0;
  margin-bottom: 10px;
  margin-top: 0;
}
.title-card .title { margin: 0; }
.title-board {
  display: inline-block;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 8px 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  border: 1px solid rgba(0,0,0,0.06);
}
.logos-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}
.logo {
  max-height: 64px;
  height: auto;
  width: auto;
  object-fit: contain;
}
@media (max-width: 600px) {
  .logo { max-height: 48px; }
}
.funding-card {
  text-align: center;
}
.back-button {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 1000;
}
</style>